import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Onesixseterurbania() {



  const cardData =
  {
    keyword: '16 Seater Urbania for Rent in Pune',
    heading: 'Amruta Travels: 16 Seater Urbania for Rent in Pune',
    headingDescription: 'Amruta Travels Pvt. Ltd. offers 16 Seater Urbania for Rent in Pune, combining luxury, comfort, and performance for group travel. Perfect for corporate events, family picnics, airport transfers, and outstation tours, our 16-seater Urbania vans provide spacious interiors, premium upholstery, and smooth air-conditioned rides. Each vehicle is maintained to the highest standards and driven by experienced chauffeurs who ensure punctuality and safety throughout your journey. Whether you’re planning a weekend getaway, wedding trip, or business travel, Amruta Travels’ 16 Seater Urbania on Rent in Pune delivers a first-class travel experience with unmatched reliability and style.',

    top: 'Top Places to Visit in Pune with Amruta Travels',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is Pune’s most iconic historical landmark, built in 1732 by the Peshwas of the Maratha Empire. Once the royal residence of Bajirao I, it reflects the grandeur of Maratha architecture with its massive gates, fountains, and gardens. The evening light and sound show brings history to life. Shaniwar Wada remains a must-visit heritage site that tells the glorious tale of Pune’s royal past."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is a symbol of India’s freedom struggle and a masterpiece of Indo-Islamic architecture. Built in 1892 by Sultan Muhammed Shah Aga Khan III, it served as a prison for Mahatma Gandhi and his wife Kasturba during the Quit India Movement. The museum inside preserves rare photos and personal belongings of Gandhi. It stands today as Pune’s monument of peace and patriotism."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, perched atop the Sahyadri hills, is a historical fortress famous for the valor of Tanaji Malusare. The fort offers breathtaking panoramic views of the surrounding valleys and is a popular trekking destination. Ancient ruins, cannons, and the Tanaji memorial make it a must-see for history lovers. Sinhagad Fort is Pune’s majestic reminder of Maratha bravery."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Dagdusheth Halwai Ganpati Temple is Pune’s spiritual heart, attracting devotees from across India. The temple’s beautifully adorned idol of Lord Ganesha is known for its grandeur and divine presence. During Ganesh Chaturthi, the area transforms into a dazzling festival of lights, music, and devotion. It’s a sacred landmark representing Pune’s deep-rooted faith and cultural pride."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is a serene escape in Pune offering panoramic city views and spiritual calm. The hilltop temple complex, dedicated to Lord Shiva and Goddess Parvati, was built during the Peshwa era. The 108-step climb rewards visitors with peace and stunning sunsets. Parvati Hill combines Pune’s heritage, spirituality, and scenic beauty in one tranquil experience."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut temple carved from basalt stone, dedicated to Lord Shiva. The temple’s circular Nandi mandapa and stone pillars showcase ancient Indian craftsmanship. Located in the city center, it offers a quiet retreat from urban hustle. Pataleshwar Temple stands as Pune’s timeless link to its ancient spiritual roots."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts showcasing India’s rich cultural heritage. From antique musical instruments to intricate carvings and rare household items, it’s a treasure trove of history. Founded by Dr. D.G. Kelkar, the museum celebrates India’s artistic excellence. It’s one of Pune’s most fascinating destinations for culture enthusiasts."
  },
  {
    "title": "Osho Ashram (Osho International Meditation Resort)",
    "description": "Located in Koregaon Park, Osho Ashram is a global meditation center attracting visitors seeking peace and transformation. Surrounded by lush greenery and tranquil gardens, it offers meditation sessions, yoga, and wellness therapies. The ashram’s modern design and spiritual vibe create a unique experience. Osho Ashram is Pune’s international hub for inner healing and mindfulness."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam is a popular weekend getaway just outside Pune, offering serene lakeside views and breezy weather. It supplies water to the city and provides a scenic backdrop for picnics and evening drives. Visitors enjoy street food stalls and photography near the lake. Khadakwasla is Pune’s peaceful escape into nature."
  },
  {
    "title": "Pune Okayama Friendship Garden",
    "description": "The Pune Okayama Friendship Garden, inspired by Japan’s Korakuen Garden, is a beautifully landscaped park in Sinhagad Road. With its flowing streams, manicured lawns, and traditional Japanese design, it offers a tranquil environment for nature lovers. Families and couples stroll along its bridges and pathways. It symbolizes Pune’s connection to global harmony and natural beauty."
  }
],



    "services": [
    {
      "name": "16 Seater Urbania for Rent in Pune",
      "description": "16 Seater Urbania for Rent in Pune offers spacious and versatile van rentals ideal for group travel, family outings, and corporate trips. These vehicles are well-maintained to ensure safety, reliability, and comfort for all passengers. With ample seating and luggage space, they are perfect for navigating Pune’s urban and suburban areas. Whether for daily commutes, weekend getaways, or special events, this service provides professional drivers and flexible rental options to accommodate diverse travel needs with ease and efficiency."
    },
    {
      "name": "Force Urbania 16 Seater Pune",
      "description": "Force Urbania 16 Seater Pune specializes in renting the robust and comfortable Force Urbania vans, known for their durability and smooth driving experience. This service caters to groups needing efficient and reliable transport for city travel or longer routes. The vehicles are regularly inspected and serviced, ensuring optimal performance. Expert drivers, familiar with Pune’s roads, prioritize passenger safety and punctuality, making this a preferred choice for both private and corporate clients."
    },
    {
      "name": "16 Seater Urbania Hire Hinjewadi",
      "description": "16 Seater Urbania Hire Hinjewadi serves the IT and corporate hub with dedicated van rental solutions tailored for office commutes, business trips, and employee transportation. Offering punctual pickups and drop-offs, this service supports flexible booking schedules aligned with client needs. Vehicles are clean, comfortable, and equipped to handle the busy traffic conditions of Hinjewadi, while trained drivers ensure a safe and pleasant journey."
    },
    {
      "name": "16 Seater Urbania Hire Baner",
      "description": "16 Seater Urbania Hire Baner provides accessible and affordable van rentals for the Baner area, suitable for family outings, group travel, and event transportation. The service focuses on convenience, safety, and comfort, with vehicles maintained to high standards. Drivers are courteous and experienced, ensuring smooth rides around Baner and to nearby destinations, with flexible timings to suit client schedules."
    },
    {
      "name": "16 Seater Urbania Hire Hadapsar",
      "description": "16 Seater Urbania Hire Hadapsar caters to the transport needs of Hadapsar residents and businesses by offering well-maintained and reliable van rentals. Whether for corporate shuttles, school outings, or social events, this service ensures timely and comfortable travel. The vans come with ample seating and luggage space, driven by professional chauffeurs who prioritize passenger safety and satisfaction."
    },
    {
      "name": "16 Seater Urbania Hire Pimpri",
      "description": "16 Seater Urbania Hire Pimpri specializes in providing dependable van rental services for the industrial and residential areas of Pimpri. This service is designed for efficient group transport, including factory employee shuttles, corporate events, and family trips. Vehicles are inspected regularly, and drivers are knowledgeable about local routes, ensuring punctual and safe transportation throughout Pimpri and surrounding areas."
    },
    {
      "name": "AC 16 Seater Urbania Pune",
      "description": "AC 16 Seater Urbania Pune offers air-conditioned van rentals that provide a cool and comfortable travel environment, especially suited for Pune’s warm climate. These vans are ideal for corporate clients, tourists, and family groups who want a premium travel experience. Equipped with modern AC systems, spacious interiors, and well-trained drivers, this service guarantees a refreshing and hassle-free journey across the city and beyond."
    },
    {
      "name": "Non AC 16 Seater Urbania Pune",
      "description": "Non AC 16 Seater Urbania Pune provides economical van rentals without air conditioning, catering to budget-conscious customers who still seek reliable and comfortable group transport. These vehicles are well-maintained and spacious, perfect for short-distance travel and local trips around Pune. The service includes professional drivers who prioritize safety and punctuality, ensuring a smooth ride without compromising quality."
    },
    {
      "name": "Luxury 16 Seater Urbania Pune",
      "description": "Luxury 16 Seater Urbania Pune delivers high-end van rentals with upgraded interiors, plush seating, and enhanced features for a premium travel experience. Ideal for VIP clients, weddings, corporate events, and special occasions, these vans combine style with comfort. Drivers are trained to provide courteous and professional service, ensuring every journey is both memorable and seamless."
    },
    {
      "name": "Corporate Urbania Hire Pune",
      "description": "Corporate Urbania Hire Pune offers specialized van rental services designed to meet the needs of businesses and organizations. This service provides reliable, punctual, and professional transport solutions for employee shuttles, corporate events, and client visits. Vehicles are clean and equipped for long hours of travel, with flexible rental plans to accommodate varying business schedules and requirements."
    },
    {
      "name": "Wedding Urbania Pune",
      "description": "Wedding Urbania Pune focuses on providing elegantly maintained vans for wedding parties, guest transportation, and related events. The vans can be customized with decorations and are driven by courteous chauffeurs who understand the importance of timing and reliability during weddings. This service ensures that guests travel comfortably and arrive on schedule, adding a touch of sophistication to the celebration."
    },
    {
      "name": "Outstation Urbania Pune",
      "description": "Outstation Urbania Pune offers long-distance van rental services for group travel outside Pune, including trips to nearby cities and tourist destinations. These vans are designed for comfort and safety on extended journeys, featuring spacious seating and adequate luggage compartments. Experienced drivers with knowledge of intercity routes ensure smooth and timely travel, making this service ideal for family vacations, corporate retreats, and group tours."
    },
    {
      "name": "Affordable Urbania Rental Pune",
      "description": "Affordable Urbania Rental Pune provides cost-effective van rental solutions for individuals and groups seeking reliable transport without compromising on quality. This service offers well-maintained vehicles at competitive rates, suitable for everyday travel, business needs, or social events. Transparent pricing, flexible booking options, and professional drivers make this a popular choice among budget-conscious customers."
    },
    {
      "name": "Online Urbania Booking Pune",
      "description": "Online Urbania Booking Pune enables customers to reserve 16-seater Urbania vans through a user-friendly digital platform. This service offers instant booking confirmation, transparent pricing, and multiple payment options for customer convenience. The platform supports route customization, pickup scheduling, and real-time support, making the booking process seamless and efficient for all types of travel requirements across Pune."
    },
    {
      "name": "Urbania Hire near Me Pune",
      "description": "Urbania Hire near Me Pune provides quick and localized access to 16-seater Urbania vans across Pune. With strategically located vehicles and responsive service, this option is perfect for last-minute bookings, daily commutes, and urgent group travel needs. The service focuses on customer convenience, offering timely pickups, professional drivers, and well-maintained vehicles for safe and comfortable journeys."
    },
    {
      "name": "Force Urbania Van Pune",
      "description": "Force Urbania Van Pune features rentals of the robust Force Urbania vans, known for their reliability and durability on Pune roads. This service targets groups needing sturdy, spacious transport with ample seating and luggage capacity. Regular maintenance and professional drivers ensure dependable and comfortable rides, whether for local city travel, corporate transport, or longer trips."
    },
    {
      "name": "Best 16 Seater Urbania Pune",
      "description": "Best 16 Seater Urbania Pune is dedicated to providing top-quality van rental services with superior vehicle condition, customer support, and driver professionalism. This service stands out for its commitment to safety, comfort, and timely service, making it a preferred choice for families, corporate groups, and event organizers looking for dependable transportation across Pune."
    },
    {
      "name": "Urbania Tour Van Pune",
      "description": "Urbania Tour Van Pune specializes in van rentals designed for sightseeing and group tours, offering comfortable and spacious vehicles ideal for exploring Pune’s attractions. These vans come equipped with large windows and amenities to enhance the travel experience. Experienced drivers also assist with navigation and local knowledge, making each tour enjoyable, informative, and hassle-free."
    }
  ],
  "tableData": [
    ["16 Seater Urbania for Rent in Pune", "Force Urbania 16 Seater Pune"],
    ["16 Seater Urbania Hire Hinjewadi", "16 Seater Urbania Hire Baner"],
    ["16 Seater Urbania Hire Hadapsar", "16 Seater Urbania Hire Pimpri"],
    ["AC 16 Seater Urbania Pune", "Non AC 16 Seater Urbania Pune"],
    ["Luxury 16 Seater Urbania Pune", "Corporate Urbania Hire Pune"],
    ["Wedding Urbania Pune", "Outstation Urbania Pune"],
    ["Affordable Urbania Rental Pune", "Online Urbania Booking Pune"],
    ["Urbania Hire near Me Pune", "Force Urbania Van Pune"],
    ["Best 16 Seater Urbania Pune", "Urbania Tour Van Pune"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "16 Seater Urbania for Rent in Pune",
    "WhyChoosedescription": "Amruta Travels Pvt Ltd provides spacious and comfortable 16 seater Urbania vehicles for rent in Pune, ideal for group travel and family outings."
  },
  {
    "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
    "WhyChoosedescription": "Our 16 seater Urbania vans are regularly serviced and thoroughly sanitized to ensure safety and comfort."
  },
  {
    "WhyChooseheading": "Transparent and Affordable Pricing",
    "WhyChoosedescription": "Benefit from clear, competitive rental rates with no hidden fees, inclusive of all taxes and charges."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans",
    "WhyChoosedescription": "Choose from hourly, daily, or long-term rental options tailored to fit your travel requirements."
  },
  {
    "WhyChooseheading": "Professional and Experienced Drivers",
    "WhyChoosedescription": "Our courteous drivers prioritize your safety and convenience, offering timely and friendly service."
  },
  {
    "WhyChooseheading": "24/7 Dedicated Customer Support",
    "WhyChoosedescription": "Our support team is available round-the-clock to help with bookings, queries, and special requests."
  },
  {
    "WhyChooseheading": "Easy and Quick Booking Process",
    "WhyChoosedescription": "Reserve your 16 seater Urbania quickly via online or phone booking, with prompt vehicle delivery across Pune."
  },
  {
    "WhyChooseheading": "Customer Satisfaction Guaranteed",
    "WhyChoosedescription": "Amruta Travels Pvt Ltd is committed to delivering reliable, comfortable, and hassle-free group travel experiences."
  }
]



























  }

const faqData = [
  {
    question: 'Does Amruta Travels Pvt Ltd offer 16 seater Urbania for rent in Pune?',
    answer: 'Yes, Amruta Travels Pvt Ltd provides 16 seater Urbania rental services in Pune, ideal for group travel and family outings.',
  },
  {
    question: 'How can I book a 16 seater Urbania for rent in Pune with Amruta Travels?',
    answer: 'You can easily book through our website, mobile app, or by contacting our 24x7 customer support team in Pune.',
  },
  {
    question: 'What amenities are available in the 16 seater Urbania vehicles in Pune?',
    answer: 'Our 16 seater Urbania vehicles come equipped with comfortable seating, air conditioning, and safety features to ensure a pleasant journey.',
  },
  {
    question: 'Are the drivers professionally trained for 16 seater Urbania rentals in Pune?',
    answer: 'Absolutely. Our drivers are experienced, courteous, and well-trained to provide a safe and comfortable ride.',
  },
  {
    question: 'Can the 16 seater Urbania be rented for special occasions and corporate events in Pune?',
    answer: 'Yes, our 16 seater Urbania vehicles are perfect for weddings, corporate outings, airport transfers, and other special events in Pune.',
  },
  {
    question: 'Is the 16 seater Urbania rental service available 24x7 in Pune?',
    answer: 'Yes, Amruta Travels offers 24x7 rental services for 16 seater Urbania vehicles in Pune to meet your schedule requirements.',
  },
  {
    question: 'What safety and hygiene protocols are followed for the 16 seater Urbania rentals?',
    answer: 'All vehicles are sanitized before each trip, and drivers adhere to strict safety and hygiene standards for passenger well-being.',
  },
  {
    question: 'What are the payment options for renting a 16 seater Urbania in Pune?',
    answer: 'We accept payments via UPI, credit/debit cards, digital wallets, and bank transfers for your convenience.',
  },
  {
    question: 'Is customer support available during the rental period of the 16 seater Urbania in Pune?',
    answer: 'Yes, our 24x7 customer support team is always available to assist you throughout your rental experience in Pune.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Karan Mehta',
    feedback: 'Renting the 16 seater Urbania from Amruta Travels in Pune was seamless. The vehicle was spacious and the driver courteous.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Rhea Sharma',
    feedback: 'Great experience with Amruta Travels. The 16 seater Urbania was comfortable and perfect for our family trip in Pune.',
    rating: 5,
  },
];



























































  const Images = [
  { place: "/images/keyword/1.jpg", text: "24 Seater Bus for Rent in Pune", link: "24-seater-bus-for-rent-in-pune" },
  { place: "/images/keyword/2.jpg", text: "16 Seater Urbania for Rent in Pune", link: "16-seater-urbania-for-rent-in-pune" },
  { place: "/images/keyword/3.jpg", text: "14 Seater Urbania Hire in Pune", link: "14-seater-urbania-hire-in-pune" },
  { place: "/images/keyword/4.jpg", text: "17 Seater Urbania Hire in Pune", link: "17-seater-urbania-hire-in-pune" },
  { place: "/images/keyword/5.jpg", text: "Mini Bus On Rent in Pimpri Chinchwad", link: "mini-bus-on-rent-in-pimpri-chinchwad" },
  { place: "/images/keyword/6.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
  { place: "/images/keyword/7.jpg", text: "Force Urbania 17 Seater On Rent in Pune", link: "force-urbania-17-seater-on-rent-in-pune" },
  { place: "/images/keyword/8.jpg", text: "35 Seater Bus On Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/9.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/10.jpg", text: "53 Seater Bus On Rent in Pune", link: "53-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/11.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/12.jpg", text: "Bus On Rent in Pune", link: "bus-on-rent-in-pune" },
  { place: "/images/keyword/13.jpg", text: "Bus Hire in Pune", link: "bus-hire-in-pune" },
  { place: "/images/keyword/14.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
  { place: "/images/keyword/15.jpg", text: "Bus Rental for Corporate Events in Pune", link: "bus-rental-for-corporate-events-in-pune" },
  { place: "/images/keyword/16.jpg", text: "Wedding Bus Booking Online Pune", link: "wedding-bus-booking-online-pune" },
  { place: "/images/keyword/17.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
  { place: "/images/keyword/18.jpg", text: "Bus Hire for Party Events in Pune", link: "bus-hire-for-party-events-in-pune" },
  { place: "/images/keyword/19.jpg", text: "Full Bus Booking for Marriage Pune", link: "full-bus-booking-for-marriage-pune" },
  { place: "/images/keyword/20.jpg", text: "AC Luxury Bus On Rent in Pune", link: "ac-luxury-bus-on-rent-in-pune" },
  { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
  { place: "/images/keyword/22.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "luxury-force-urbania-on-rent-in-pune" },
  { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Pune for Corporate", link: "urbania-on-rent-in-pune-for-corporate" },
  { place: "/images/keyword/24.jpg", text: "Pune to Goa Urbania On Rent", link: "pune-to-goa-urbania-on-rent" },
  { place: "/images/keyword/25.jpg", text: "Pune to Mumbai Urbania on Rent", link: "pune-to-mumbai-urbania-on-rent" }
];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "16 Seater Urbania for Rent in Pune",
  "image": "https://www.amrutatravelspvtltd.com/images/keyword/2.jpg",
  "description": "Book a 16 Seater Urbania for Rent in Pune with Amruta Travels Pvt. Ltd. offering comfortable and luxurious Force Urbania vans for local, corporate, wedding, and outstation travel. Choose AC or Non-AC options at affordable prices.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels Pvt. Ltd."
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "16847"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2800",
    "availability": "https://schema.org/InStock",
    "url": "https://www.amrutatravelspvtltd.com/16-seater-urbania-for-rent-in-pune"
  }
};






  return (
    <div>
<Helmet>
  <title>16 Seater Urbania for Rent in Pune | Luxury Force Urbania Hire | Amruta Travels Pvt. Ltd.</title>
  <meta
    name="description"
    content="Book 16 Seater Urbania for Rent in Pune with Amruta Travels Pvt. Ltd. offering luxury and affordable Force Urbania vans for corporate, wedding, and outstation trips. Available in AC and Non-AC options."
  />
  <meta
    name="keywords"
    content="16 Seater Urbania for Rent in Pune, Force Urbania 16 Seater Pune, 16 Seater Urbania Hire Hinjewadi, 16 Seater Urbania Hire Baner, 16 Seater Urbania Hire Hadapsar, 16 Seater Urbania Hire Pimpri, AC 16 Seater Urbania Pune, Non AC 16 Seater Urbania Pune, Luxury 16 Seater Urbania Pune, Corporate Urbania Hire Pune, Wedding Urbania Pune, Outstation Urbania Pune, Affordable Urbania Rental Pune, Online Urbania Booking Pune, Urbania Hire near Me Pune, Force Urbania Van Pune, Best 16 Seater Urbania Pune, Urbania Tour Van Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

<section className="page-header">
        <div
          className="page-header__bg"
          style={{
            backgroundImage: "url(/images/page-header-bg-1-1.jpg)",
          }}
        ></div>
        <div className="container">
          <div className="page-header__content">
            <h2 className="page-header__title">   {cardData.keyword}</h2>
          </div>
        </div>
      </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/2.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Amruta Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Amruta Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918010014995" className="pc-call">+91 8010014995</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918010014995"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918010014995" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@amrutatravelspvtltd.com" className="pc-email">
                      booking@amrutatravelspvtltd.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Amruta Travels Pvt Ltd</strong><br />
                      Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Onesixseterurbania;